// import { Pipe, PipeTransform } from '@angular/core';

// @Pipe({
//   name: 'timeDifference',
//   pure: true,
// })
// export class TimeDifferencePipe implements PipeTransform {
//   transform(createdTime: any): string {
//     if (createdTime) {
//       const currentTime = new Date();
//       const localOffset = currentTime.getTimezoneOffset() * 60000; // Offset in milliseconds
//       const localTime = new Date(createdTime.getTime() - localOffset); // Convert to local time
//       const timeDifference = currentTime.getTime() - localTime.getTime();
//       return this.formatTimeDifference(timeDifference);
//     } else {
//       return 'Invalid Date';
//     }
//   }

//   private formatTimeDifference(milliseconds: number): string {
//     // Convert milliseconds to seconds
//     const seconds = Math.floor(milliseconds / 1000);

//     // Format seconds to a human-readable format (e.g., "x seconds ago")
//     if (seconds < 60) {
//       return `${seconds} seconds ago`;
//     } else if (seconds < 3600) {
//       const minutes = Math.floor(seconds / 60);
//       return `${minutes} minutes ago`;
//     } else if (seconds < 86400) {
//       const hours = Math.floor(seconds / 3600);
//       return `${hours} hours ago`;
//     } else if (seconds < 604800) {
//       const days = Math.floor(seconds / 86400);
//       return `${days} days ago`;
//     } else {
//       const weeks = Math.floor(seconds / 604800);
//       return `${weeks} weeks ago`;
//     }
//   }
// }
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'timeDifference',
  pure: true,
})
export class TimeDifferencePipe implements PipeTransform {
  transform(createdTime: any): string {
    if (!createdTime) {
      return 'Invalid date'; // Handles null, undefined, or empty input
    }

    const inputDate = new Date(createdTime);
    if (isNaN(inputDate.getTime())) {
      return 'Invalid date'; // Input is not a valid date
    }

    const currentTime = new Date();
    const timeDifference = currentTime.getTime() - inputDate.getTime();

    return this.formatTimeDifference(timeDifference);
  }

  private formatTimeDifference(milliseconds: number): string {
    const seconds = Math.floor(milliseconds / 1000);
    if (seconds < 60) {
      return `${seconds} seconds ago`;
    } else if (seconds < 3600) {
      const minutes = Math.floor(seconds / 60);
      return `${minutes} minute${minutes > 1 ? 's' : ''} ago`;
    } else if (seconds < 86400) {
      const hours = Math.floor(seconds / 3600);
      return `${hours} hour${hours > 1 ? 's' : ''} ago`;
    } else if (seconds < 604800) {
      const days = Math.floor(seconds / 86400);
      return `${days} day${days > 1 ? 's' : ''} ago`;
    } else {
      const weeks = Math.floor(seconds / 604800);
      return `${weeks} week${weeks > 1 ? 's' : ''} ago`;
    }
  }
}
